import { FILE_SIZE_LIMITS } from './constants';

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};

export const isImage = (type: string): boolean => type.startsWith('image/');
export const isVideo = (type: string): boolean => type.startsWith('video/');
export const isDocument = (type: string): boolean =>
  type === 'application/pdf' || type.includes('officedocument');

export const generateFileId = (): string =>
  `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;

export const validateFileSize = (file: File): void => {
  if (isImage(file.type) && file.size > FILE_SIZE_LIMITS.IMAGE.BYTES) {
    throw new Error(
      `El archivo "${file.name}" excede el límite de ${FILE_SIZE_LIMITS.IMAGE.MB}MB para imágenes`
    );
  }
  if (isVideo(file.type) && file.size > FILE_SIZE_LIMITS.VIDEO.BYTES) {
    throw new Error(
      `El archivo "${file.name}" excede el límite de ${FILE_SIZE_LIMITS.VIDEO.MB}MB para videos`
    );
  }
  if (isDocument(file.type) && file.size > FILE_SIZE_LIMITS.DOCUMENT.BYTES) {
    throw new Error(
      `El archivo "${file.name}" excede el límite de ${FILE_SIZE_LIMITS.DOCUMENT.MB}MB para documentos`
    );
  }
};
